import { useContext } from "react";
import { RecaptchaContext } from "../providers/RecaptchaProvider";

export default function useRecaptcha() {
  return useContext(RecaptchaContext);
}
